import PropTypes from 'prop-types';

import { showMessageBox } from '@utils/messageBox';

export const REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_MESSAGE = 'Report as working and invoiceable';

export const INVALID_SELECTION_MULTIPLE_EVENTS_REPORT_WORKING_INVOICEABLE = 'Invalid selection to report ' +
    'as working and invoiceable';

export const INVALID_SELECTION_MULTIPLE_EVENTS_MESSAGE = 'Reporting as working and invoiceable is possible ' +
    'only for a selection of events having at least one distribution which is reportable or invoiceable.' +
    ' Please correct your selection.';

export const REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_FAILURE_MESSAGE =
    'The selected events could not be reported as working and invoiceable successfully.';

export const REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_SUCCESS_MESSAGE =
    'The selected events have been reported as working and invoiceable successfully.';

export const reportMultipleAsWorkingAndInvoiceableErrorHandler = (name, text) => {
    showMessageBox(
        name,
        REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_MESSAGE,
        text,
        'error',
        true
    );
};

reportMultipleAsWorkingAndInvoiceableErrorHandler.propTypes = {
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export const reportMultipleAsWorkingAndInvoiceableResponseHandler = (response, messageBoxName, message) => {
    showMessageBox(
        messageBoxName,
        REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_MESSAGE,
        message,
        'success',
        true
    );
};

reportMultipleAsWorkingAndInvoiceableResponseHandler.propTypes = {
    response: PropTypes.object.isRequired,
    errorHandler: PropTypes.func.isRequired,
    messageBoxName: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};
